import { z } from 'zod';

const eventConfigSchema = z.object({
  enabled: z.boolean(),
  eventName: z.string()
});

export const appsFlyerS2SSchema = z
  .object({
    enabled: z.boolean(),
    s2sToken: z.string(),
    appIds: z.array(z.string()),
    events: z.object({
      'payment-success': eventConfigSchema,
      refund: eventConfigSchema
    })
  })
  .superRefine((data, ctx) => {
    if (!data.enabled) {
      return;
    }

    if (!data.s2sToken.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid token',
        path: ['s2sToken']
      });
    }

    if (data.appIds.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Enter application ID',
        path: ['appIds', 0]
      });
    } else {
      data.appIds.forEach((id, index) => {
        if (!id.trim()) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Enter application ID',
            path: ['appIds', index]
          });
        }
      });
    }

    const purchase = data.events['payment-success'];
    if (purchase.enabled && !purchase.eventName.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Enter event name',
        path: ['events', 'payment-success', 'eventName']
      });
    }

    const refund = data.events.refund;
    if (refund.enabled && !refund.eventName.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Enter event name',
        path: ['events', 'refund', 'eventName']
      });
    }
  });

export type AppsFlyerS2SFormValues = z.infer<typeof appsFlyerS2SSchema>;
